/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Tenant } from './Tenant';
const TenantRoleWithTenantParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['name', codecString],
    ['tenant', Tenant],
]);
export class TenantRoleWithTenant extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TenantRoleWithTenantParser.decode(input).map(res => new TenantRoleWithTenant(res));
    }
    static unsafeDecode(input) {
        return TenantRoleWithTenant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantRoleWithTenantParser.encode(data);
    }
    static schema() {
        return TenantRoleWithTenantParser.schema();
    }
}
